import { FeatureCallout } from '@doxyme/ui/components/foundations';
import { LinkS } from '@doxyme/ui/typography';
import { useTheme } from '@doxyme/ui/theme';
import { FormattedMessage, useIntl } from '@doxyme/locale';
import { AppLink } from '../../../global/appLink';

import type { JSX } from 'react';

const HELP_ARTICLE_LINK =
  'https://helpcenter.doxy.me/en/articles/9893441-invite-via-email-and-text';

export type InviteViaRateLimitTrialMessageProps = {
  messageKey: string;
  date: Date;
  onUpgrade: () => void;
};

export const InviteViaRateLimitTrialMessage = ({
  messageKey,
  onUpgrade,
}: InviteViaRateLimitTrialMessageProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const getTitleKey = (key: string): string => `${key}.title`;

  return (
    <FeatureCallout
      title={formatMessage({ id: getTitleKey(messageKey) })}
      description={
        <FormattedMessage
          id='rate-limit.invite-not-trusted.description'
          values={{
            link: (
              <AppLink
                target='_blank'
                rel='noreferrer'
                href={HELP_ARTICLE_LINK}
              >
                <LinkS
                  css={{ fontSize: theme.typography.captionLink.fontSize }}
                >
                  <FormattedMessage id='rate-limit.helpArticle' />
                </LinkS>
              </AppLink>
            ),
          }}
        />
      }
      actionText={formatMessage({ id: 'upgrade' })}
      onClick={onUpgrade}
      type='upgrade'
    />
  );
};
